import axios from "axios";
export default {
    getSettings: () => axios.post("/Settings/GetSettings", {}),
    getSettingsTypeDictionary: () => axios.post("/Settings/GetSettingsTypeDictionary", {}),
    testConnection: (data) => axios.post("/Settings/TestConnection", data),
    reloadOntology: (signalRConnectionId) => axios.post("/Settings/ReloadOntology", { signalRConnectionId }),
    saveConnection: (data) => axios.post("/Settings/SaveConnection", data),
    saveSetting: (data) => axios.post("/Settings/SaveSetting", data)
};
